module.exports = __webpack_public_path__ + "img/chrysler.9d2ae129.png";